module.exports = __webpack_public_path__ + "static/Ubuntu-Bold-e00e2a77dd88a8fe75573a5d993af76a.ttf";